import type { ReactNode } from "react";
import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { useAuth } from "../context/AuthContext";
import "./Layout.css";

export function Layout({ children }: { children: ReactNode }) {
  const { authenticated, loading } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="layout">
      <Sidebar 
        mobileMenuOpen={mobileMenuOpen} 
        onClose={() => setMobileMenuOpen(false)} 
      />
      <div className="layout-main">
        <TopBar onMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />
        <main className="layout-content">
          {loading || !authenticated ? (
            <div style={{ padding: 48, textAlign: "center", color: "#888" }}>
              Authenticating...
            </div>
          ) : (
            children
          )}
        </main>
      </div>
      {mobileMenuOpen && (
        <div 
          className="layout-overlay" 
          onClick={() => setMobileMenuOpen(false)}
          aria-hidden="true"
        />
      )}
    </div>
  );
}
